// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".template-games[data-v-361d4490]{padding-top:0!important}.template-games__header[data-v-361d4490]{margin-bottom:16px}@media(min-width:768px){.template-games__header[data-v-361d4490]{margin-bottom:24px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
